import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SnowflakeSearchParams, SnowflakeSearchResult } from '../interfaces/workflows/SnowflakeSearchResult';
import { Page, SnowflakeViewResponse } from '@monorepo/interfaces';

@Injectable({ providedIn: 'root' })
export class SnowflakeSearchService {
    private http = inject(HttpClient);

    public search(
        params: SnowflakeSearchParams,
        page: number,
        pageSize: number
    ): Observable<Page<SnowflakeSearchResult>> {
        const requestBody = {
            coreMlfbs: params.coreMlfb
                .split(',')
                .map(part => part.trim())
                .filter(part => part),
            gck: params.gck,
            pck: params.pck,
            priceGroup: params.priceGroup,
            page,
            pageSize
        };

        return this.http
            .post<SnowflakeViewResponse>(`${environment.apiConfig[0].uri}/snowflake/products`, requestBody)
            .pipe(
                map((response): Page<SnowflakeSearchResult> => ({
                    items: response.items.map(item => ({
                        coreMlfb: item.productNumber,
                        gck: item.gck,
                        pck: item.pck,
                        priceGroup: item.priceGroup
                    })),
                    metadata: response.metadata
                }))
            );
    }
}
